var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "externalLink_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.235 1.593c.194.141.32.37.32.63v4.666a.778.778 0 1 1-1.555 0v-2.79l-9.043 9.044a.778.778 0 0 1-1.1-1.1L15.9 3h-2.789a.778.778 0 1 1 0-1.556h4.667a.774.774 0 0 1 .457.149Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.976 5.087c.34-.34.802-.531 1.283-.531h6.222a.778.778 0 0 1 0 1.555H3.26a.26.26 0 0 0-.259.26v10.37a.26.26 0 0 0 .26.26h10.37a.26.26 0 0 0 .259-.26v-6.222a.778.778 0 0 1 1.555 0v6.222a1.815 1.815 0 0 1-1.814 1.815H3.26a1.815 1.815 0 0 1-1.816-1.815V6.37c0-.482.192-.943.532-1.284Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#externalLink_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-17.778-17.778h55.556v55.556h-55.556v-55.556Z"
  }))));
};

export default SvgExternalLink;